import api from '../api';


export function getStory(storyId) {
    return api.get(`/stories/${storyId}`).then(response => response.data);
}

export function listStories(accountId) {
    return api.get(`/stories?account_id=${accountId}`).then(response => response.data);
}

export function createStory(accountId, name, description, projectIds) {
    return api.post(`/stories`, {
        'account_id': accountId,
        'name': name,
        'description': description,
        'project_ids': projectIds
    }).then(response => response.data);
}

export function renameStory(storyId, name) {
    return api.post(`/stories/${storyId}/rename`, {
        'name': name,
    }).then(response => response.data);
}

export function changeStoryDescription(storyId, description) {
    return api.post(`/stories/${storyId}/change-description`, {
        'description': description,
    }).then(response => response.data);
}

export function updateProjects(storyId, projectIds) {
    return api.patch(`/stories/${storyId}`, {
        'project_ids': projectIds,
    }).then(response => response.data);
}

export function removeStory(storyId) {
    return api.delete(`/stories/${storyId}`).then(response => response.data);
}

export function createPost(storyId, integrationId) {
    return api.post(`/stories/${storyId}/create_posts`, {
        'integration_id': integrationId,
    }).then(response => response.data);
}

export function publishStory(storyId) {
    return api.post(`/stories/${storyId}/publish`).then(response => response.data);
}

export function unpublishStory(storyId) {
    return api.post(`/stories/${storyId}/unpublish`);
}

export function duplicate(storyId) {
    return api.post(`/stories/${storyId}/duplicate`).then(response => response.data);
}